import moment from "moment";
import request from '@/router/axios';
import {
  dictionaries,
  queryInventedId,
  queryBjId
} from "@/api/factoring/factoringCustomer";
import { validatenull } from "@/util/validate";

export default {
  methods: {


    
    /***
     *      保理业务字典查询方法
     *      传参格式参照
     *       let dataList = [
                { code: "cust_type_rzzl", name: "custType" },
                { code: "bl_cust_attribute", name: "custAttribute" },
                { code: "enterprise_type", name: "enterpriseType" },
                { code: "enterprise_scale", name: "enterpriseScale" },
            ];
     * 
     * */
    dictionaryMap(dataList, dataInfo) {
      return new Promise(async (resolve, reject) => {
        let returnData = {}
        let codeList = dataList.map((item) => {
          return item.code;
        });
        let res = await dictionaries(`code=${codeList.join(",")}`);
        if (res.data.code == 200) {
          let dataSource = {};
          dataList.map((item) => {

            let num = (dataInfo[item.name] + '').indexOf(",");

            dataSource[item.name + "Str"] = "";
            if (num > -1) {
              dataInfo[item.name] = dataInfo[item.name] ?
                dataInfo[item.name].split(",") : [];
            }

            res.data.data[item.code].filter((el) => {
              if (num > -1) {

                dataInfo[item.name].map((item_) => {

                  if (parseFloat(el.dictKey) == parseFloat(item_)) {
                    dataSource[item.name + "Str"] = dataSource[item.name + "Str"] ?
                      dataSource[item.name + "Str"] + "," + el.dictValue :
                      el.dictValue;
                  }

                });
              } else {
                if (parseFloat(el.dictKey) == parseFloat(dataInfo[item.name])) {
                  dataSource[item.name + "Str"] = el.dictValue;
                }
              }
            });
          });
          returnData = {
            ...dataInfo,
            ...dataSource,

          };
         
          resolve(returnData)
        } else {
          reject(res)
        }
      })
    },

    /***
     *      保理业务字典查询方法，
     *      传参格式参照
     *       let dataList = [
                { code: "zs_project_type", name: "zsProjectTypeList" },
                { code: "zs_project_status", name: "zsProjectStatusList" },
            ];
            返回格式参照：
              dictionaryData:{
                zsProjectTypeList:[],
                zsProjectStatusList:[]
              }
     * 
     * */
    dictionaryAllMap(dataList) {
      return new Promise(async (resolve, reject) => {
        let returnData = {}
        let codeList = dataList.map((item) => {
          return item.code;
        });
        let res = await dictionaries(`code=${codeList.join(",")}`);
        if (res.data.code == 200) {
          let dataSource = {};
          dataList.map(item=>{
             if(res.data.data[item.code]){
              dataSource[item.name]=res.data.data[item.code]
             }
          })
          returnData = {
            ...dataSource,

          };
         
          resolve(returnData)
        } else {
          reject(res)
        }
      })
    },
    /***
     *      列表和详情页 根据dictKey获取对应字典的 dictValue
     *      与 上面的 dictionaryAllMap() 配合使用
     *      dictField：字段名称 string  参考：zs_project_type 必填
     *      dataList ：字典数组  array  参考：zsProjectTypeList  必填 
     *      dictKey：  字典数组的dictKey值 string 默认为 dictKey，可不传
     *      dictValue：字典数组的dictValue值 string 默认为 dictValue，可不传   
     * */

    dictionaryLabel(dictField, dataList=[],dictKey="dictKey",dictValue="dictValue"){ 
      if(!validatenull(dictField)){
          let filterList=dataList.filter(item=>{
          return item[dictKey]==dictField
          })
          if(filterList.length>0){
            return filterList.map(item=>item[dictValue]).join(",")
          }else {
              return '/'
          }
      }else{
        return '/'
      }
    },
    //创建一个新id
    setNewId() {
      return new Promise(async (resolve, reject) => {
        let res = await queryInventedId();
        if (res.data.code == 200) {

          resolve(res.data.data)
        } else {
          reject(res)
        }
      })
    },
    //创建一个新id，报价方案专用
    setNewBjId() {
      return new Promise(async (resolve, reject) => {
        let res = await queryBjId();
        if (res.data.code == 200) {

          resolve(res.data.data)
        } else {
          reject(res)
        }
      })
    },
    // 日期格式转换 YYYYMMDD 格式为YYYY-MM-DD  YYYY年MM月DD日
    dateConvert(val) {
      val = (val + "").replace(/^(\d{4})(\d{2})(\d{2})$/, "$1-$2-$3");

      return val;
    },

    queryDict(value, queryUrl) {
      return new Promise((resolve, reject) => {
        request({
          url: queryUrl,
          method: 'get',
        }).then(res => {
          if (res.data.code == 200) {
            let dictData = res.data.data
            if ( value && (value !== '' || value == 0)) {
              let returnData = dictData.filter(item => {
                return item.dictKey == value
              })
              
              resolve(returnData.length>0?returnData[0].dictValue:'')
            } else {
              resolve('')
            }
          }
        })
      })
    },

    queryDictData(queryUrl) {
      return new Promise((resolve, reject) => {
        request({
          url: queryUrl,
          method: 'get',
        }).then(res => {
          if (res.data.code == 200) {
            resolve(res.data.data)
          }
        })
      })
    },

    /**
     * 修改表单配置参数
     * @param {Array} column 表单配置
     * @param {String} key1 prop值
     * @param {String} key2 要修改的参数
     * @param {String} value 修改的值
     */
    changeOptionConfig(column, key1, key2, value) {
      column.map(item => {
        if (item.prop == key1) {
          item[key2] = value;
        }
      })
      return column
    },

    // 表格数据合并
    mergeTableRow(config) {
      let data = config.data;
      const {
        mergeColNames,
        firstMergeColNames,
        firstMerge
      } = config;
      if (!mergeColNames || mergeColNames.length === 0) {
        return data;
      }
      mergeColNames.forEach((m) => {
        const mList = {};
        data = data.map((v, index) => {
          const rowVal = v[m];
          if (mList[rowVal] && mList[rowVal].newIndex === index) {
            const flag =
              firstMergeColNames.filter((f) => {
                return f === m;
              }).length !== 0;
            const mcFlag =
              mergeColNames.filter((mc) => {
                return mc === firstMerge;
              }).length === 0;
            if (
              (mcFlag && flag) ||
              (flag &&
                data[index][firstMerge + "-span"] &&
                data[index][firstMerge + "-span"].rowspan === 1)
            ) {
              v[m + "-span"] = {
                rowspan: 1,
                colspan: 1,
              };
            } else {
              data[mList[rowVal]["index"]][m + "-span"].rowspan++;

              v[m + "-span"] = {
                rowspan: 0,
                colspan: 0,
              };
              mList[rowVal]["num"]++;
              mList[rowVal]["newIndex"]++;
            }
          } else {
            mList[rowVal] = {
              num: 1,
              index: index,
              newIndex: index + 1
            };
            v[m + "-span"] = {
              rowspan: 1,
              colspan: 1,
            };
          }
          return v;
        });
      });
      return data;
    },

  
   
  }
}
